// GSAP Parallax - Works on all images with these specific classes
gsap.registerPlugin(ScrollTrigger);

// Handle all .parralaxImage elements
gsap.utils.toArray(".parralaxImage").forEach((element) => {
  // Set initial state
  gsap.set(element, {
    yPercent: -40,
    scale: 1,
  });

  // Create parallax animation
  gsap.to(element, {
    yPercent: 15,
    scale: 1.1,
    ease: "none",
    scrollTrigger: {
      trigger: element, 
      start: "center bottom",
      end: "bottom top",
      scrub: true
    }
  });
});

// Handle all .parralaxImageTwo elements
gsap.utils.toArray(".parralaxImageTwo").forEach((element) => {
  // Set initial state
  gsap.set(element, {
    yPercent: -20,
    scale: 1,
  });

  // Create parallax animation
  gsap.to(element, {
    yPercent: 10,
    scale: 1.1,
    ease: "none",
    scrollTrigger: {
      trigger: element, 
      start: "top bottom",
      end: "bottom top",
      scrub: true
    }
  });
});